//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

//客户余额-定义公式因子
const formulaFactors = () =>
  import('@/pages/purchaseSalesCenter/customerBalance/basicSetting/formulaFactors.vue');
//客户余额-计算配置
const computationalFormula = () =>
  import('@/pages/purchaseSalesCenter/customerBalance/basicSetting/computationalFormula.vue');
//客户余额调整新增
const adjustmentAdd = () =>
  import('@/pages/purchaseSalesCenter/customerBalance/adjustment/add.vue');
//客户余额调整编辑
const adjustmentEdit = () =>
  import('@/pages/purchaseSalesCenter/customerBalance/adjustment/edit.vue');
//客户余额调整详情
const adjustmentDetail = () =>
  import('@/pages/purchaseSalesCenter/customerBalance/adjustment/detail.vue');
//客户余额调整查询
const adjustmentList = () =>
  import('@/pages/purchaseSalesCenter/customerBalance/adjustment/list.vue');
//客户余额查询
const customerBalanceList = () => import('@/pages/purchaseSalesCenter/customerBalance/list.vue');

const customerBalanceRouter = {
  path: '/customerBalance',
  component: index,
  children: [
    {
      path: 'formulaFactors',
      name: 'formulaFactors',
      component: formulaFactors,
      meta: {
        keepAlive: true,
        title: '定义因子',
      },
    },
    {
      path: 'computationalFormula',
      name: 'computationalFormula',
      component: computationalFormula,
      meta: {
        keepAlive: true,
        title: '客户余额计算配置',
      },
    },
    {
      path: 'adjustmentAdd',
      name: 'adjustmentAdd',
      component: adjustmentAdd,
      meta: {
        keepAlive: true,
        title: '客户余额调整新增',
      },
    },
    {
      path: 'adjustmentEdit',
      name: 'adjustmentEdit',
      component: adjustmentEdit,
      meta: {
        keepAlive: true,
        title: '客户余额调整编辑',
      },
    },
    {
      path: 'adjustmentDetail',
      name: 'adjustmentDetail',
      component: adjustmentDetail,
      meta: {
        keepAlive: true,
        title: '客户余额调整详情',
      },
    },
    {
      path: 'adjustmentList',
      name: 'adjustmentList',
      component: adjustmentList,
      meta: {
        keepAlive: true,
        title: '客户余额调整查询',
      },
    },
    {
      path: 'customerBalanceList',
      name: 'customerBalanceList',
      component: customerBalanceList,
      meta: {
        keepAlive: true,
        title: '客户余额查询',
      },
    },
  ],
};
export default customerBalanceRouter;
